var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4494_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17891 14.625C7.64844 12.7441 11 8.18555 11 5.625C11 2.51953 8.53646 0 5.5 0C2.46354 0 0 2.51953 0 5.625C0 8.18555 3.35156 12.7441 4.82109 14.625C5.17344 15.0732 5.82656 15.0732 6.17891 14.625ZM5.5 3.75C5.98623 3.75 6.45255 3.94754 6.79636 4.29917C7.14018 4.65081 7.33333 5.12772 7.33333 5.625C7.33333 6.12228 7.14018 6.59919 6.79636 6.95083C6.45255 7.30246 5.98623 7.5 5.5 7.5C5.01377 7.5 4.54745 7.30246 4.20364 6.95083C3.85982 6.59919 3.66667 6.12228 3.66667 5.625C3.66667 5.12772 3.85982 4.65081 4.20364 4.29917C4.54745 3.94754 5.01377 3.75 5.5 3.75Z",
    fill: "url(#paint0_linear_4494_474)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4494_474",
    x1: 0,
    y1: 7.48059,
    x2: 11,
    y2: 7.48059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#702B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#443E65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4494_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6151dc6fc66fc216d8304ca57119bdfe.svg";
export { ForwardRef as ReactComponent };